const targetRechargeRule = () => import('@/views/main/target/recharge-rule/recharge-rule.vue')
export default {
  path: '/main/target/targetRechargeRule',
  name: 'targetRechargeRule',
  component:targetRechargeRule,
  children: []
}
